// extracted by mini-css-extract-plugin
export default {"whtList":"whiteList_whtList__nEBl8","mainDiv":"whiteList_mainDiv__haRIE"};